module.exports = __webpack_public_path__ + "static/media/RoundedCornerSluCS.240a8e94.png";


//////////////////
// WEBPACK FOOTER
// ./src/Components/RoundedCornerSluCS.png
// module id = 42
// module chunks = 0